import { createGlobalStyle } from 'styled-components';

import CenturyGothicBold from '@/assets/fonts/centurygothic_bold.ttf';
import Background from '@/assets/icons/cover-images/blue_trivia_background.png';

const VariationsStyles = createGlobalStyle`
  @font-face {
    font-family: 'CenturyGothicBold';
    src: url(${CenturyGothicBold});
  }   
  
  .generated-images-holder-var22 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var22 {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
  }
  .right-holder-var22 {
    width: 50%;
    height: 100%;
    display: flex;
    background: url(${Background}) no-repeat center center;
    flex-direction: column;
  }
  .right-image-holder-var22 {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .trivia-icon-var22 {
    margin-top: 43px;
    margin-left: 5px;
  }
  .right-text-var22 {
    flex: 1;
    overflow: hidden;
    line-height: 1.2;
    letter-spacing: 0.7px;
    text-transform: uppercase;
    text-align: center;
    color: #fff;
    font-family: CenturyGothicBold;
    display: flex;
    font-weight: 700;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;
   text-shadow: 
    -2px 3px 5px #2029a6,
    -2px 3px 5px #2029a6;
  }
  .break-var22 {
    position: absolute;
    background-color: white;
    width: 12px;
    height: 100%;
    left: 0;
    top: 0;
    right: 0;
    margin-left: calc(50% - 6px);
    z-index: 1;
  }
  .half-image-var22 {
    width: 50%;
    height: 100%;
    object-fit: cover;
    position: relative;
    display: block;
  }
  .actual-photo-var22 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 72px;
  }
  .actual-photo-var22--top {
    top: 0;
    bottom: auto;
  }
`;

export default VariationsStyles;
